module.exports = __webpack_public_path__ + "static/soju.40b0e863.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/soju.png
// module id = 155
// module chunks = 7